const KEY = "partyboss_booking_flow_v1";
const ADDON_META_KEY = "partyboss_addon_meta_v1";

export function saveBookingFlow(data) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(data));
  } catch {
    /* ignore quota */
  }
}

export function loadBookingFlow() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

/** Persist fetchMeta payload so /booknow/addons survives refresh (Context resets). */
export function persistAddonMeta(meta) {
  try {
    sessionStorage.setItem(ADDON_META_KEY, JSON.stringify(meta ?? {}));
  } catch {
    /* ignore */
  }
}

export function loadPersistedAddonMeta() {
  try {
    const raw = sessionStorage.getItem(ADDON_META_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
}

export function clearBookingFlow() {
  try {
    sessionStorage.removeItem(KEY);
    sessionStorage.removeItem(ADDON_META_KEY);
  } catch {
    /* ignore */
  }
}

/** Convert selected add-on array to object keyed by id (ReviewAddons expects object entries). */
export function addonsArrayToMap(selectedAddon) {
  if (!selectedAddon || !Array.isArray(selectedAddon)) return {};
  return selectedAddon.reduce((acc, item) => {
    if (item?.id != null) acc[item.id] = item;
    return acc;
  }, {});
}
